import {
  ENTER_OTP_VALUE,
  OTP_SENT,
  get_request_config
} from '@/utils/system_constants/constant.js';
import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';
export default {
  name: 'OneTimePin',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data() {
    return {
      title: "Verify Your Account",
      submit_button_text: "Login",
      verification_running: false,
      otp_number: '',
      otp_sending: false
    };
  },

  methods: {

    async handle_enter_otp() {
      this.verification_running = true;

      const data = {
        one_time_password: this.otp_number,
        user_id: this.$store.getters.currentUserId
      };

      try {
        const response = await axios.post(
          ENTER_OTP_VALUE,
          data,
          get_request_config()
        );

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        if (response_data.status === 'success') {
          sessionStorage.setItem('otp_verified', 'true');
          this.show_success('OTP verified successfully');
          await this.$router.replace({ name: 'GlobalOverview' });
        } else {
          this.show_error(response_data.message || 'Error during OTP verification');
        }
      } catch (error) {
        this.show_error(
          error?.response?.data?.message || 'Please enter a valid OTP.'
        );
      } finally {
        this.verification_running = false;
      }
    },

    async resend_otp() {
      if (this.otp_sending) return;

      this.otp_sending = true;
      const user_id = this.$store.getters.currentUserId;

      try {
        const response = await axios.post(
          OTP_SENT,
          { user_id },
          get_request_config()
        );

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        if (response_data.status === 'success') {
          this.show_success('OTP has been resent successfully.');

          if (response_data.user_id) {
            this.$store.dispatch('setCurrentUserId', response_data.user_id);
          }
        } else {
          this.show_error(response_data.message || 'Could not send OTP.');
        }
      } catch (error) {
        this.show_error(
          error?.response?.data?.message || 'Could not send OTP to user.'
        );
      } finally {
        this.otp_sending = false;
      }
    }
  }
};
